import { useState } from 'react'

import classNames from 'classnames'
import styled from 'styled-components'

import ItemTableHeaderRow from 'components/Core/Table/ItemTableHeaderRow'
import Table from 'components/Core/Table/Table'

import styles from './SummaryTable.module.css'
import {
  GroupingTableProps,
  SummaryData,
  SummaryTableProps,
} from './SummaryTable.types'
import {
  renderExpandableRows,
  renderGeneralRow,
  summaryTableColumnOrder,
  summaryTableColumns,
} from './SummaryTable.utils'

const checkIfTableIsEmpty = (summaryTableData: SummaryData): boolean =>
  !summaryTableData.aggregated && summaryTableData.orders.length === 0

const SummaryTable = ({
  summaryTableData,
}: SummaryTableProps): JSX.Element | null => {
  if (checkIfTableIsEmpty(summaryTableData)) return null

  return (
    <GroupingTable
      summaryData={summaryTableData}
      columns={summaryTableColumns}
      columnOrder={summaryTableColumnOrder}
    />
  )
}

const GroupingTable = ({
  summaryData,
  columns,
  columnOrder,
}: GroupingTableProps): JSX.Element | null => {
  const { aggregated, orders } = summaryData
  const [allRowsExpanded, setAllRowsExpanded] = useState(false)
  const [anyRowExpanded, setAnyRowExpanded] = useState(false)

  const onExpandAnyRow = (anyOpen: boolean): void => {
    setAnyRowExpanded(anyOpen)
  }
  const onExpandAllRows = (): void => {
    setAnyRowExpanded(!allRowsExpanded)
    setAllRowsExpanded(!allRowsExpanded)
  }

  if (!aggregated && orders.length <= 0) return null

  return (
    <StyledTable
      testId="summaryTable"
      fullWidth={true}
      className={classNames(styles.AllocationTable)}
    >
      {/* @ts-expect-error */}
      <Table.Header fullWidth={true}>
        <ItemTableHeaderRow
          columns={columns}
          columnOrder={columnOrder}
          hasSelectColumn={false}
          isForExpandableTable={true}
          anyRowExpanded={anyRowExpanded}
          onExpandAllRows={onExpandAllRows}
          className={styles.tableHeader}
        />
      </Table.Header>
      <Table.Body>
        <>
          {renderExpandableRows(
            orders,
            {
              columns,
              columnOrder,
              rowsExpanded: allRowsExpanded,
            },
            onExpandAnyRow,
          )}
          {renderGeneralRow(aggregated, {
            columns,
            columnOrder,
            isExpandedRow: true,
          })}
        </>
      </Table.Body>
    </StyledTable>
  )
}

const StyledTable = styled(Table)`
  &&& th,
  &&& td {
    line-height: var(--line-height-16);
    box-sizing: border-box;
    vertical-align: middle;

    &:last-child > div {
      text-align: end;
    }
  }
`

export default SummaryTable
